import React, { memo, useEffect, useState, useRef } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import acceptSound from "./play.mp3";
import findGif from "../css/loading_old.gif";
import playSound from "./play.mp3";
import { useHistory } from "react-router-dom";


import { MdOutlineDelete } from "react-icons/md";
const BetCard = React.memo(


  ({
    allgame,
    
    deleteChallenge,
    getPost,
    challangeReqRun,
    RejectGame,
    winnAmount,
    AcceptChallang,
    updateChallenge,
    
  }) => {

     // BASE URL
 
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
}
// +++++++++++++++++++++++++++++ 
    const history = useHistory();
    const [disable, setDisable] = React.useState(challangeReqRun);
    const [disable_play, setDisable_play] = React.useState(false);
    
    const user = localStorage.getItem("userId");

    const req_chall_fun = (allgameId) => {
    getPost(allgameId);
};
    const isMounted = useRef(true);
    // const [socket, setSocket] = useState();
    const disablebtn = (id) => {
      setDisable(true);
      setTimeout(() => {
        setDisable(false);
      }, 10000);
      //  sendMessage()
    };

    const disable_play_btn = () => {
      setDisable_play(true);
      setTimeout(() => {
        setDisable_play(false);
      }, 3000);
      // status_fun()
    };

    let state = {
      creator: "123",
      acceptor: "321",
      gameId: "ujhgf532dgbh63",
    };

    return (
      <div
        className={`${css.betCard} mt-2  battle_card_main card_bottom_border`}
      >
        <span
          className={`${css.betCardTitle}  d-flex align-items-center  ${css.betTitleDiv} headings`}
        >
          Challange From
          <span className="ml-1" style={{ color: "brown" }}>
            {allgame?.Created_by?.Name}
          </span>
          {user == allgame?.Created_by?._id && allgame?.Status == "new" && (
            <button
              className={`  ml-auto delete_buttons`}
              onClick={() => deleteChallenge(allgame?._id)}
            >
              {/* DELETE */}
              <MdOutlineDelete className="card_icons" />
            </button>
          )}
          {user == allgame?.Created_by?._id &&
            allgame?.Status == "requested" && (
              <div className="d-flex ml-auto align-items-center">
                <Link style={{ bottom: "0" }}>
                  <button
                    className={`bg-success position-relative mx-1 btn-sm text-white btn-inverse-success`}
                    disabled={disable}
                    style={{ display: disable ? "none" : "block" }}
                    onClick={(e) => {
                      disablebtn(allgame?._id);
                      req_chall_fun(allgame?._id);
                      
                    }}
                  >
                    Start
                  </button>
                  <button
                    className={
                      disable
                        ? "btn btn-primary d-block"
                        : "btn btn-primary d-none"
                    }
                  >
                    Wait
                  </button>
                </Link>
                <button
                  className={
                    disable
                      ? "d-none text-white bg-danger position-relative mx-1 btn-sm btn-outline-youtube"
                      : "text-white bg-danger position-relative mx-1 btn-sm btn-outline-youtube d-block"
                  }
                  onClick={() => RejectGame(allgame?._id)}
                  style={{ bottom: "0" }}
                >
                  Reject
                </button>
              </div>
            )}
        </span>
        <div className={`  ${css.betBodyDiv} battle_card_inner_bottom`}>
          {/* Entry Fee */}
          <div className="">
            <span className={css.betCardSubTitle}>Entry Fee</span>
            <div>
            ₹
              <span className={css.betCardAmount}>{allgame?.Game_Ammount}</span>
            </div>
          </div>
          
          {user !== allgame?.Created_by?._id && allgame?.Status == "new" && (
            <button
              className={`   samll_btn  battle_plat_btn play_btn_color`}
              disabled={disable_play}
              onClick={() => {
                disable_play_btn();
                AcceptChallang(allgame?._id);
              }}
            >
              Play
            </button>
          )}
          {user == allgame?.Created_by?._id && allgame?.Status == "new" && (
            <div className="pl-2 text-center">
              <img src={findGif} style={{ width: "25px", height: "25px" }} />
            </div>
          )}
          {user !== allgame?.Created_by?._id &&
            allgame?.Status == "requested" && (
              <div className="d-flex  align-items-center">
                <div
                  className={`  position-relative mx-1 text-white btn-sm request_btn`}
                >
                  requested
                </div>
                <button
                  className={`  position-relative mx-1 btn-sm reject_btn`}
                  onClick={() => RejectGame(allgame?._id)}
                >
                  cancel
                </button>
              </div>
            )}
          {user !== allgame?.Created_by?._id &&
            allgame?.Status == "running" && (
              <div className="">
                <audio src={playSound} autoPlay></audio>

                <Link>
                  <button
                    disabled={disable}
                    className={`samll_btn start_btn_color'`}
                    style={{ background: "#783cd6" }}
                    onClick={(e) => {
                      disablebtn();
                      updateChallenge(allgame?._id);
                      history.push(`/viewgame1/${allgame?._id}`, {
                        prevPath: window.location.pathname,
                      });
                    }}
                  >
                    
                    Start
                  </button>
                </Link>
              </div>
            )}
          {user == allgame?.Created_by?._id &&
            allgame.Status == "requested" && (
              <div className="">
                <audio src={acceptSound} autoPlay></audio>

                <div className="text-center col">
                  <div className="pl-2">
                    {allgame?.Accepetd_By?.avatar ? (
                      <img
                        src={baseUrl+`${allgame?.Accepetd_By?.avatar}`}
                        alt=""
                        width="40px"
                        height="40px"
                        style={{
                          borderTopLeftRadius: "50%",
                          borderTopRightRadius: "50%",
                          borderBottomRightRadius: "50%",
                          borderBottomLeftRadius: "50%",
                          marginTop: "5px",
                        }}
                      />
                    ) : (
                      <img
                        src="/images/avatars/Avatar1.png"
                        alt=""
                        width="40px"
                        height="40px"
                        style={{
                          borderTopLeftRadius: "50%",
                          borderTopRightRadius: "50%",
                          borderBottomRightRadius: "50%",
                          borderBottomLeftRadius: "50%",
                          marginTop: "5px",
                        }}
                      />
                    )}
                  </div>
                  <div style={{ lineHeight: 1 }}>
                    <span className="bet_player_name">
                      {allgame?.Accepetd_By.Name}
                    </span>
                  </div>
                </div>
              </div>
            )}

          {/* prize */}
          <div>
            <span className={css.betCardSubTitle}>Prize</span>
            <div>
              <span className={css.betCardAmount}>
              ₹
                {allgame?.Game_Ammount + winnAmount(allgame?.Game_Ammount)}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
);



export default memo(BetCard);
